import axios from 'axios'
const url = 'https://www.lefisc.com.br/api/indicadores'
export default {
    getValor(dataInicio, dataFim, Valor,hash,id) {
        return axios
            .post(`${url}/calcular/`, {
                "dataInicio":`${dataInicio}`,
                "dataFim":`${dataFim}`,
                "valor":Valor,
                "hash":hash,
                "id":id
            })
            .then(res => res)
            .catch(err =>err.response);
    },
    textos(id){
        return axios
        .get(`https://www.lefisc.com.br/api/indicadores/textoCategorias/${id}`)
        .then(res => res.data)
        .catch(err => console.log(err));
    },
    categorias(hash){
        return axios
            .post(`https://www.lefisc.com.br/api/indicadores/listarCategorias`, {               
                "hash":hash
            })
            .then(res => res.data)
            .catch(err => console.log(err));
        
    },
    buscarHash(login){
        return axios
            .post(`https://www.lefisc.com.br/api/login/GerarHash`, 
                login
            )
            .then(res => res.data)
            .catch(err => console.log(err));
    }
}